<h2 mat-dialog-title>Confirm Email</h2>
<mat-dialog-content>
  <h6 style="width: 100%; text-align: center;">for contact profile creation</h6>

  @if (data.admin_email === '') {
    <div style="margin-top: 16px;">
      <label>Hubspot Email <span style="color:#ffbe00;">*No Internal Email Found</span></label>
      <p>{{data.hs_email}}</p>
    </div>
  }

  @if (data.hs_email === '') {
    <div style="margin-top: 16px;">
      <label>Hubspot/Internal Email</label>
      <p>{{data.admin_email}}</p>
    </div>
  }

  @if (data.hs_email === data.admin_email && data.hs_email !== '') {
    <div style="margin-top: 16px;">
      <label>Internal Email <span style="color:#ffbe00;">*No Hubspot Email Found</span></label>
      <p>{{data.admin_email}}</p>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="confirm()">Confirm</button>
</mat-dialog-actions>
